function isValidAppRoute(url) {
  if (typeof url !== "string") {
    return false;
  }

  try {
    const decodedUrl = decodeURIComponent(url);
    return decodedUrl.startsWith("/s/");
  } catch {
    return false;
  }
}

export { isValidAppRoute };
